import { isEmpty } from 'lodash';
import InformationBox from '../../../../components/other/informationBox';
import { useTranslation } from 'react-i18next';

const InitialAssessmentSummary = ({ patient }) => {
    const { t } = useTranslation();
    const text = patient?.initialAssessment?.additionalInformation;
    if (isEmpty(text)) return null;

    return (
        <InformationBox type="info" label={t('Initial Assessment Summary')}>
            {text}
        </InformationBox>
    );
};

export default InitialAssessmentSummary;
